import * as pdfjsLib from "pdfjs-dist";

// Configurar o caminho do worker corretamente
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

export async function PDFtoIMG(base64PDF: string) {
  try {
    const byteCharacters = atob(base64PDF);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const pdfDoc = await pdfjsLib.getDocument({ data: byteArray }).promise;

    const pages: { page: number; image: string }[] = [];

    const renderPage = async (pageNum: number) => {
      const page = await pdfDoc.getPage(pageNum);
      const scale = 1.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) return;

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = { canvasContext: context, viewport };
      await page.render(renderContext).promise;

      const base64Image = canvas.toDataURL("image/jpeg");

      // add page
      pages.push({ page: pageNum, image: base64Image });
    };

    const pagePromises = [];
    for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
      pagePromises.push(renderPage(pageNum));
    }
    await Promise.all(pagePromises);

    return {
      success: true,
      pages: pages.sort((a, b) => a.page - b.page),
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
}

export async function PDFtoText(base64PDF: string) {
  try {
    const byteCharacters = atob(base64PDF);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const pdfDoc = await pdfjsLib.getDocument({ data: byteArray }).promise;
    const pages: { page: number; text: string }[] = [];

    const extractPageText = async (pageNum: number) => {
      const page = await pdfDoc.getPage(pageNum);
      const content = await page.getTextContent();

      // Ordenar os textos com base nas coordenadas (y DESC, x ASC)
      const items = content.items.map((item: any) => ({
        text: item.str,
        x: item.transform[4],
        y: item.transform[5],
      }));

      items.sort((a, b) => {
        if (b.y !== a.y) return b.y - a.y; // Prioriza a ordem das linhas
        return a.x - b.x; // Depois, ordena os textos na mesma linha
      });

      const text = items.map((item) => item.text).join(" ");

      pages.push({ page: pageNum, text });
    };

    const pagePromises = [];
    for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
      pagePromises.push(extractPageText(pageNum));
    }
    await Promise.all(pagePromises);

    return {
      success: true,
      pages: pages.sort((a, b) => a.page - b.page),
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
}
